export type HttpMethod = 'get' | 'delete' | 'post' | 'put' | 'patch' | 'head';

export type HttpHeaderValue = string | string[] | undefined;

export type HttpHeaders = Record<string, HttpHeaderValue>;

export type GenericHttpRequest = {
  method: HttpMethod;
  url: string;
  host?: string;
  headers?: Record<string, string>;
  query?: unknown;
  /** A string is sent as is, anything else as JSON. */
  body?: unknown;
};

export type GenericHttpResponse = {
  status: number;
  statusText?: string;
  headers: HttpHeaders;
  body: unknown;
  request: GenericHttpRequest;
};

export type GenericHttpRequestOptions = {
  abortSignal?: AbortSignal;
  timeoutMs?: number;
};

/** Thrown by every transport for a non-2xx response. */
export class GenericHttpError extends Error {
  request: GenericHttpRequest;

  response: GenericHttpResponse;

  constructor(request: GenericHttpRequest, response: GenericHttpResponse) {
    super(`${response.status} ${response.statusText}`);
    this.request = request;
    this.response = response;
  }
}

export type GenericHttpTransport = (
  request: GenericHttpRequest,
  options?: GenericHttpRequestOptions,
) => Promise<GenericHttpResponse>;
